var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multi-selection-tool-button',{attrs:{"icon":"delete","disabled":_vm.disabled ||
      (_vm.nrObjectsSelected && _vm.nrObjectsSelected === 0) ||
      !_vm.canUseTool('destroy'),"tooltip":_vm.$t('DeleteSelected')},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-886c55cc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_Atoms/TableToolbarButtons/Delete.vue
// module id = null
// module chunks = 